module.exports = __webpack_public_path__ + "img/bttn_library_feeds_off.5c1f3f90.svg";